import { render, staticRenderFns } from "./LandCard.vue?vue&type=template&id=7ea99dcc&scoped=true"
import script from "./LandCard.vue?vue&type=script&lang=js"
export * from "./LandCard.vue?vue&type=script&lang=js"
import style0 from "./LandCard.vue?vue&type=style&index=0&id=7ea99dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea99dcc",
  null
  
)

export default component.exports